const en = {
	nav: {
		home: 'Home',
		about: 'About Me',
		work: 'My Projects',
		contact: 'Contact Me'
	},
	contactModal: {
		title: 'Contact Me',
		sendEmail: 'Send Email',
		chatWhatsApp: 'Chat on WhatsApp',
		visitVantech: 'Go to Vantech'
	},
	home: {
		profileAlt: 'Profile',
		videoAlt: 'Transparent Video',
		techPartners: 'Technology partners',
		roles: [
			'Web Designer',
			'Creative Thinker',
			'UI/UX Enthusiast',
			'Front-End Developer'
		]
	},
	about: {
		greeting: "Hi, I'm Rodrigo",
		paragraph1:
			"I'm a {webDesigner} and {uxSpecialist} with over 4 years of professional experience. I studied systems engineering at ITESO University in Guadalajara, Mexico.",
		webDesigner: 'web designer',
		uxSpecialist: 'UI/UX specialist',
		paragraph2:
			"I currently work at {breken} and {vantech}. I'm always looking for new projects to {colaborar} and {aprender} new things.",
		breken: 'Breken',
		vantech: 'Vantech',
		colaborar: 'collaborate',
		aprender: 'learn',
		paragraph3:
			"I'm passionate about {disenar} and {desarrollar} my clients' {suenos}, always seeking the {mejorExperiencia} user experience and the {mejorCalidad} in code.",
		disenar: 'designing',
		desarrollar: 'developing',
		suenos: 'dreams',
		mejorExperiencia: 'best',
		mejorCalidad: 'highest quality',
		paragraph4:
			'Discover more about my work by checking out my {proyectos}',
		proyectos: 'projects',
		downloadCV: 'Download CV',
		photoAlt: 'Rodrigo Alvarez'
	},
	work: {
		filters: {
			all: 'All',
			commercial: 'Commercial',
			learning: 'Learning'
		},
		sectionTitle: 'My Projects'
	},
	footer: {
		tagline: 'Web Designer & UI/UX Specialist',
		navigation: 'Navigation',
		home: 'Home',
		about: 'About Me',
		work: 'Projects',
		contact: 'Contact',
		copyright: 'All rights reserved.'
	},
	sidebar: {
		ariaLabel: 'Section navigation',
		sections: {
			home: 'Home',
			about: 'About Me',
			work: 'My Projects'
		}
	},
	loading: {
		ariaLabel: 'Loading portfolio',
		tagline: 'Portfolio'
	},
	projectCard: {
		learningBadge: 'Learning',
		confidential: 'Confidential Project',
		underConstruction: 'Under construction'
	},
	projectModal: {
		closeLabel: 'Close',
		confidential: 'Confidential Project',
		confidentialDesc:
			'This project cannot be shown due to confidentiality agreements.',
		learningBadge: 'Learning',
		descriptionTitle: 'Project description',
		gallery: 'Gallery',
		viewGitHub: 'View on GitHub',
		viewLive: 'View live project'
	},
	projects: {
		breken: {
			description:
				'Logistics system for tracking cargo trucks for loading and unloading domestic products.',
			date: 'March 2023 - Present',
			extendedDescription:
				'Breken is a complete logistics system that integrates administration, operation, and tracking into a single platform. It allows automating logistics processes, managing trips and billing, and monitoring units in real time through its app.\n\nIn this project, I was able to participate from its design, development, and current maintenance. Primarily in the development of the user interface and the integration of the app with the system. Breken has a system that allows complete management from the cloud.\n\nRole in the project: Web and mobile interface design and development, app-system integration, feature development, and system maintenance.'
		},
		sistemaPacientes: {
			description:
				'Internal patient management system designed and developed by Vantech.',
			date: 'September 2025 - February 2026',
			extendedDescription:
				'Internal patient management system designed and developed by Vantech to streamline patient registration, appointments, payments, and prescriptions across multiple locations, with real-time synchronization and support for high-demand sessions.\n\nThe system is built with React, Tailwind CSS, AWS, and PostgreSQL. It allows users to register patients, schedule appointments, process payments and prescriptions, and view patient history.\n\nRole in the project:\n\nUser interface design and development, server-system integration, feature development, and system maintenance.'
		},
		miel: {
			description:
				'Website for Miel de la Cruz, a honey sales company with a cause.',
			date: 'February 2026 - March 2026',
			extendedDescription:
				'Miel de la Cruz is a company dedicated to the production and sale of pure honey and related products such as propolis, granola, natural syrups, and personal care. The web platform features an online store, product showcases, sustainability information, and an experiences section, all designed to highlight the quality and natural origin of their products from Aguascalientes, Mexico.\n\nI transitioned from design to pixel-perfect development of the elegant and professional platform with store, blog, and contact sections. I implemented custom cursor effects and performance optimization for a smooth user experience.'
		},
		jowibay: {
			description: 'Mobile app for agricultural product catalog.',
			date: 'October 2024 - April 2025',
			extendedDescription:
				"JowiBay is a mobile app designed to connect agricultural producers with buyers directly, functioning as a digital catalog where suppliers can showcase their products and buyers can discover new sourcing options.\n\nIn this project, I primarily participated in the design and development of the user interface, focusing on creating a clear, functional, and accessible experience for both types of users: producers and buyers. The app was designed to facilitate catalog navigation, product visualization, and direct communication between stakeholders.\n\nThe platform is built with Supabase, used for data management, authentication, and backend structure. Additionally, the app features an in-app subscription system, allowing users to access functionalities or benefits based on their chosen plan.\n\nOne of JowiBay's main features is its integrated chat system, which allows suppliers and buyers to communicate directly within the application. However, the app does not process payments or transactions between users; its primary purpose is to serve as a contact point and commercial showcase, functioning as an interactive catalog for the agricultural sector.\n\nFrom a UI perspective, the work focused on designing clean, intuitive, and easy-to-use screens, prioritizing visual product presentation, information organization, and smooth navigation. The interface was designed to convey trust, simplicity, and usefulness, adapting to the needs of users looking to sell or find agricultural products quickly and directly.\n\nRole in the project:\n\nMobile interface design and development, user experience, main screen design, navigation, product catalog, chat interface, and subscription-related flows within the app."
		},
		kibox: {
			description:
				'Redesign of the Kibox website, a cardboard sales company.',
			date: 'November 2023 - December 2023',
			extendedDescription:
				"Kibox is a company dedicated to selling high-quality cardboard. With the Vantech team, we carried out a complete redesign of Kibox's website to improve the representation of their luxury products with a new logo, fresh colors, and updated typography. We also reorganized product designs and presentations to make everything clear and attractive.\n\nRole in the project:\n\nWebsite design and development, rebranding, product and presentation reorganization."
		},
		aires: {
			description: 'Trip management system for Aires Operadora.',
			date: 'September 2023 - December 2023',
			extendedDescription:
				"Aires Operadora is a travel and tourism agency. They don't just sell trips, they sell complete experiences, and that's what we wanted to reflect in the redesign of their website.\n\nRole in the project:\n\nWebsite design and development, rebranding."
		},
		vantech: {
			description: 'Website for Vantech, a software development company.',
			date: 'August 2023 - November 2023',
			extendedDescription:
				'At Vantech, we make your dreams come true. From conception to implementation, we ensure your project is a success.\n\nAny technology solution, from web to app, we make it a reality.\n\nRole in the project:\n\nWebsite design and development, rebranding.'
		},
		spgps: {
			description: 'Website for Sp GPS.',
			date: 'July 2023 - October 2023',
			extendedDescription:
				"SP GPS is a company dedicated to selling GPS and navigation equipment. With the Vantech team, we carried out a complete redesign of SP GPS's website to improve the representation of their products and services.\n\nRole in the project:\n\nWebsite design and development, rebranding."
		},
		brekenmx: {
			description: 'Website for the Breken company.',
			date: 'April 2023 - August 2023',
			extendedDescription:
				'Breken.mx is the commercial website for Breken software, a trip management and logistics platform.\n\nFor this website, I handled the design and development, focusing on usability and user experience.\n\nRole in the project:\n\nWebsite design and development.'
		},
		inco: {
			description: 'Website for the Inco company.',
			date: 'February 2023 - May 2023',
			extendedDescription:
				'Inco is the logistics company behind the development of Breken, trip management and logistics software.\n\nFor this website, I handled the design and development, focusing on usability and user experience.\n\nRole in the project:\n\nWebsite design and development.'
		},
		fitroutine: {
			description:
				'FitRoutine is a mobile-first web app for creating, managing, and tracking workout routines.',
			date: 'June 2026 - Present',
			extendedDescription:
				'FitRoutine is a fullstack local-first application designed for users to create, organize, and track their workout routines from any device on the same network.\n\nThe frontend is built with React 19 and TypeScript, using Vite as the build tool and React Router for navigation. The interface follows a mobile-first approach with CSS Modules, supporting three visual themes (dark, light, sunset) and two languages (English, Spanish) through a custom context-based i18n system.\n\nThe backend uses Node.js with Express 5 and TypeScript, following a layered architecture (routes → controllers → services → database). Data persistence is handled by Prisma ORM with SQLite, keeping all data local without requiring external services or cloud infrastructure.\n\nKey features include a complete exercise library with muscle group and equipment categorization, a drag-and-drop routine builder, real-time workout session tracking with set marking, workout history with daily summaries, and QR code generation for instant phone access.\n\nRole in the project:\n\nRESTful API design, database schema management with migrations, responsive interface, state management, and device synchronization over a local network.'
		}
	},
	skills: {
		softSkills: {
			teamwork: {
				skill: 'Teamwork',
				description:
					'Ability to collaborate effectively with other team members, sharing knowledge and working towards common goals.'
			},
			communication: {
				skill: 'Effective communication',
				description:
					'Skill in conveying ideas clearly and concisely, both verbally and in writing, adapting the message to the audience.'
			},
			adaptability: {
				skill: 'Adaptability',
				description:
					'Ability to quickly adjust to new environments, technologies, and methodologies while maintaining a high level of productivity.'
			},
			problemSolving: {
				skill: 'Problem solving',
				description:
					'Ability to analyze complex situations, identify problems, and develop effective and creative solutions.'
			},
			learningAbility: {
				skill: 'Learning ability',
				description:
					'Willingness and ability to continuously acquire new knowledge and skills, staying up to date in the field.'
			}
		}
	}
}

export default en
